export const campaignStatusMap: { [K in CampaignStatusType]: string } = {
  NEW: 'New',
  ACTIVE: 'Active',
  STOPPED: 'Stopped',
  EXPIRED: 'Expired'
}

export const readableCampaignFieldMap: { [key: string]: string } = {
  campaignId: 'Campaign ID',
  name: 'Campaign name',
  status: 'Campaign status',
  description: 'Campaign description',
  startTime: 'Start date',
  endTime: 'End date',
  financialTarget: 'Financial target',
  engagementPlan: 'Engagement plan',
  createdAt: 'Campaign created at'
}

export function sortCampaignsByCharityId(campaigns: CharityCampaignType[]) {
  return campaigns.reduce(
    (acc, campaign) => {
      const charityId = campaign.charityId

      if (!acc[charityId]) {
        acc = {
          ...acc,
          [charityId]: []
        }
      }

      acc = {
        ...acc,
        [charityId]: [...acc[charityId], campaign].sort(sortCampaignsByDate)
      }

      return acc
    },
    {} as { [key: string]: CharityCampaignType[] }
  )
}

function sortCampaignsByDate(a: CharityCampaignType, b: CharityCampaignType) {
  const dateA = new Date(a.startTime)
  const dateB = new Date(b.startTime)
  return dateA < dateB ? 1 : -1
}
